export enum BookingErrors {
  GET_SERVICES_LIST = 'Ошибка при получении списка услуг',
  GET_CALENDAR_MONTH_INFO = 'Ошибка при получении данных календаря на месяц',
  GET_EMPLOYEES_MONTH_SCHEDULE = 'Ошибка при получении графиков сотрудников',
  CREATE_SERVICE = 'Ошибка при создании услуги',
  WORK_DAY_CREATE = 'Ошибка при создании правила рабочего дня',
  GET_WORK_TIME_RULES = 'Ошибка при получении правил рабочего времени',
  WORK_DAY_DELETE = 'Ошибка при удалении правила рабочего дня',
  WORK_BREAK_CREATE = 'Ошибка при создании правила перерыва',
  WORK_BREAK_DELETE = 'Ошибка при удалении правила перерыва',
  GET_DAY_FREE_SLOTS_RULES = 'Ошибка при получении свободных слотов на день',
  CREATE_BOOKING = 'Ошибка при создании записи',
  GET_CALENDAR_DAY = 'Ошибка при получении данных календаря на день',
  GET_CALENDAR_BOOKING = 'Ошибка при получении данных о записи',
  DELETE_BOOKING = 'Ошибка при удалении записи',
  GET_CALENDAR_WEEK_INFO = 'Ошибка при получении данных календаря на неделю',
  GET_CALENDAR_BREAK = 'Ошибка при получении данных о перерыве',
  CREATE_SERVICE_CATEGORY = 'Ошибка при создании категории услуги',
  DELETE_SERVICE_CATEGORY = 'Ошибка при удалении категории услуги',
  UPDATE_SERVICE_CATEGORY = 'Ошибка при обновлении категории услуги',
  EDIT_SERVICE = 'Ошибка при редактировании услуги',
  DELETE_SERVICE = 'Ошибка при удалении услуги',
  DAY_OVERRIDE = 'Ошибка при создании переопределения дня',
  BREAK_OVERRIDE = 'Ошибка при создании перерыва',
  UPDATE_BOOKING = 'Ошибка при обновлении записи',
  UPDATE_BREAK_OVERRIDE = 'Ошибка при обновлении перерыва',
  DELETE_BREAK_OVERRIDE = 'Ошибка при удалении перерыва',
}
